














import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import users from './store/modules/users';

@Component
export default class App extends Vue {
  private async created() {
    try {
      const user = await users.getLoggedUser();
      if (!user) {
        await this.logout();
      }
    } catch (err) {
      return err;
    }
  }

  private async logout() {
    await users.logout();
    this.$router.push({ name: 'login' });
  }
}
